import { render, staticRenderFns } from "./Fairways.vue?vue&type=template&id=7230c554&"
import script from "./Fairways.vue?vue&type=script&lang=js&"
export * from "./Fairways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports